class FreeSample extends HTMLElement {

    constructor() {
        super();

        if(!this.checkCookie()) {
            console.log('S1 blocked by cookie');
            this.closest('.cart__contents').classList.add('hidden')
            return;
        }
        console.log('reached here s1')
        this.select = this.querySelector('select');
    
        // document.addEventListener('DOMContentLoaded', this.initialize.bind(this))
        this.select.addEventListener('change', this.onChange.bind(this))
        this.onCartUpdate()
    }
    
    checkCookie() {
        if(document.querySelector('cart-drawer').classList.contains('sampling-s1')) {
            const samplingD = new Date();
            const samplingExDays = 356;
            samplingD.setTime(samplingD.getTime() + (samplingExDays*24*60*60*1000));
            document.cookie = "sampling_version=S1; expires=" + samplingD.toUTCString() + "; path=/";
        }
    
        let samplingVersion = this.getCookie("sampling_version");
        if (samplingVersion == 'S1') {
            window.ElevarDataLayer = window.ElevarDataLayer || [];
            window.ElevarDataLayer.push({ event: "dl_sampling", sampling_type: 'S1' });
            return true;
        } else {
            return false
        }
    }
    
    getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
    }

    initialize() {

        if(!this.checkCookie()) {
            console.log('S1 blocked by cookie');
            this.closest('.cart__contents').classList.add('hidden')
            return;
        }
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            this.onCartUpdate();
        });

        this.onCartUpdate()
    }
    cartUpdateUnsubscriber = undefined;

    connectedCallback() {
        if(!this.checkCookie()) {
            console.log('S1 blocked by cookie');
            this.closest('.cart__contents').classList.add('hidden')
            return;
        }
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === 'cart-items') {
                return;
            }
            this.onCartUpdate();
        });
    }
  
    disconnectedCallback() {
        if(!this.checkCookie()) {
            console.log('S1 blocked by cookie');
            this.closest('.cart__contents').classList.add('hidden')
            return;
        }
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }
    }
    onCartUpdate() {
        console.log('cart update')
        let self = document.querySelector('free-sample')
        if(parseInt(self.dataset.subtotal) < parseInt(this.dataset.threshold)) {
            this.select.setAttribute('disabled', 'disabled')
        } else {
            this.select.removeAttribute('disabled')
        }
        let sku = this.select.options[this.select.selectedIndex].dataset.sku
        let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if(this.dataset.hasSample == 'false' && (parseInt(self.dataset.subtotal) >= parseInt(this.dataset.threshold))) {
            let formData = {
                'items': [{
                    'id': this.dataset.variantId,
                    'quantity': 1,
                    properties: {
                        '__free_sample': this.select.value,
                        '__free_sample_version': 'S1',
                        '__skus': '1x' + sku,
                        'Fragrance': this.select.options[this.select.selectedIndex].text
                    }
                }],
                'sections': cart.getSectionsToRender().map((section) => section.id),
                'sections_url': window.location.pathname
            };
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                return response.json();
            })
            .then((response) => {
                cart.renderContents(response);
                self.handleRecharge()
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }
        if(this.dataset.hasSample != 'false' && (parseInt(self.dataset.subtotal) < parseInt(this.dataset.threshold))) {
            console.log('remove sample')
            let formData = {
                'id': this.dataset.hasSample,
                'quantity': 0,
                'sections': cart.getSectionsToRender().map((section) => section.id),
                'sections_url': window.location.pathname
            };
            fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                return response.json();
            })
            .then((response) => {
                cart.renderContents(response);
                self.handleRecharge()
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }
    }

    handleRecharge() {
        if(typeof reChargeCartJS == 'function') {
            console.log('CU - sample 2')
            let hasSubscriptions = false
            const newItems = document.querySelectorAll('.cart-item');
            newItems.forEach((item)=>{
                if(item.dataset.isSubscription) {
                    if(JSON.parse(item.dataset.isSubscription)) {
                        hasSubscriptions = true
                    }
                }
            })
            window.ReCharge.cart_options.disable = !hasSubscriptions;
            reChargeCartJS()
        } 
    }

    onChange(event) {
        let self = this
        event.preventDefault()
        let sku = this.select.options[this.select.selectedIndex].dataset.sku
        let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        let formData = {
            'id': this.dataset.hasSample,
            'quantity': 1,
            properties: {
                '__free_sample': this.select.value,
                '__free_sample_version': 'S1',
                '__skus': '1x' + sku,
                'Fragrance': this.select.options[this.select.selectedIndex].text
            },
            'sections': cart.getSectionsToRender().map((section) => section.id),
            'sections_url': window.location.pathname
        };
        fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            return response.json();
        })
        .then((response) => {
            cart.renderContents(response);
            self.handleRecharge()
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
}

customElements.define('free-sample', FreeSample);

class FreeSamples2 extends HTMLElement {
    
    constructor() {
        super();

        this.loadingOverlay = this.querySelector('.loading-overlay')
        this.removeSample = this.querySelector('a[data-remove-sample]')
        if(this.removeSample) {
            this.removeSample.addEventListener('click', this.removeSampleClick.bind(this))
        }

        if(!this.checkCookie()) {
            console.log('S2 blocked by cookie');
            this.classList.add('hidden')
            if(this.dataset.active && (this.dataset.activeId == this.dataset.activeVariantId)) {
                if(this.removeSample) {
                    this.removeSample.click()
                }
            }
            return;
        }

        document.addEventListener("swiper-loaded", this.initCartSwiper.bind(this))
        this.initCartSwiper()
        // this.onCartUpdate()


        if(this.dataset.active == 'false') {
            if(this.removeSample) {
                this.removeSample.click()
            }
            return;
        }

        this.selects = this.querySelectorAll('.select dl')
        if(this.selects.length > 0) {
            this.selects.forEach((dl)=>{
                dl.addEventListener('click', this.selectClick.bind(dl))
                dl.addEventListener('mouseleave', this.selectLeave.bind(dl))
            })
        }
        this.selectOptions = this.querySelectorAll('.select li')
        if(this.selectOptions.length > 0) {
            this.selectOptions.forEach((li)=>{
                li.addEventListener('click', this.selectOptionClick.bind(this))
            })
        }
        this.renderCartAttributes()
    }

    // initialize() {
    //     console.log('S2 init');
    //     this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    //         this.onCartUpdate();
    //     });
    // }

    cartUpdateUnsubscriber = undefined;

    connectedCallback() {
        if(!this.checkCookie()) {
            console.log('S2 blocked by cookie');
            this.classList.add('hidden')
            return;
        }
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            this.onCartUpdate();
        });
    }
  
    disconnectedCallback() {
        if(!this.checkCookie()) {
            console.log('S2 blocked by cookie');
            this.classList.add('hidden')
            return;
        }
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }
    }

    showLoader() {
        this.loadingOverlay.classList.remove('hidden')
    }
    
    hideLoader() {
        this.loadingOverlay.classList.add('hidden')
    }

    renderCartAttributes() {
        // console.log('render');
        let formData = {
            attributes: {
                'S2': null,
                'S2: Sample': null,
                // 'S2: First Use': null,
                'S2: Category Hopper': null,
                'S2: Category': null,
                'S2: Sample Category': null,
                // 'S2: Count': null,
            }
        };
        if(this.dataset.activeId.length > 0) {
            formData = {
                attributes: {
                    'S2': true,
                    'S2: Sample': this.dataset.activeId,
                    // 'S2: First Use': this.dataset.firstUse == 'true',
                    'S2: Category Hopper': this.dataset.categoryHopper == 'true',
                    'S2: Category': this.dataset.category,
                    'S2: Sample Category': this.dataset.sampleCategory,
                    // 'S2: Count': this.dataset.s2Count,
                }
            }   
        }
        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            return response.json();
        })
        .then((response) => {
            console.log('Added cart attributes')
            console.log(formData)
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    onCartUpdate() {
        console.log('onCartUpdate - S2')
        // console.log(this)
        // let self = document.querySelector('free-samples2')
        // console.log(self.dataset.subtotal)
        // console.log(this.dataset.threshold)
        // if(parseInt(self.dataset.subtotal) < parseInt(this.dataset.threshold)) {
        //     if(this.removeSample) {
        //         this.removeSample.click()
        //     }
        // }
    }

    removeSampleClick(event) {
        console.log('remove S2');
        event.preventDefault();
        this.showLoader()
        let sampleId = this.dataset.activeId
        const sampleVariantId = this.dataset.activeVariantId
        if(sampleVariantId && (sampleVariantId != sampleId)) { // Handle S1 sample if in cart
            sampleId = sampleVariantId
        }
        // console.log(sampleId + ' - ' + sampleVariantId)
        let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const self = this

        let formData = {
            'id': sampleId,
            'quantity': 0,
            'sections': cart.getSectionsToRender().map((section) => section.id),
            'sections_url': window.location.pathname
        };
        console.log(formData);
        fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            return response.json();
        })
        .then((response) => {
            console.log(response)
            cart.renderContents(response);
            self.handleRecharge() // TODO check if recharge needs handling
            self.hideLoader()
        })
        .catch((error) => {
            console.error('Error:', error);
            self.hideLoader()
        });
    }

    selectOptionClick(event) {
        event.preventDefault()
        event.stopPropagation();
        this.showLoader()
        // console.log(event.target)

        event.target.closest('dl').classList.remove('active')

        const variantId = event.target.dataset.variantId
        const groupName = event.target.dataset.groupName
        const productGroupName = event.target.dataset.productGroupName
        let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const self = this

        let formData = {
            'items': [{
                'id': variantId,
                'quantity': 1,
                properties: {
                    '__free_sample': variantId,
                    '__free_sample_version': 'S2',
                    '__free_sample_group_name': groupName,
                    '__free_sample_product_group_name': productGroupName,
                    // 'Fragrance': event.target.innerText
                }
            }],
            'sections': cart.getSectionsToRender().map((section) => section.id),
            'sections_url': window.location.pathname
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            return response.json();
        })
        .then((response) => {
            cart.renderContents(response);
            self.handleRecharge() // TODO check if recharge needs handling
            self.hideLoader()
        })
        .catch((error) => {
            console.error('Error:', error);
            self.hideLoader()
        });
    }

    selectLeave(event) {
        this.classList.remove('active')
    }

    selectClick(event) {
        this.classList.toggle('active')
    }

    initCartSwiper() {
        if(typeof this.swiper == 'undefined' && typeof Swiper != 'undefined') {
            console.log(this.querySelectorAll('.swiper-slide').length)
            this.swiper = new Swiper(this.querySelector('.swiper'), {
                // Optional parameters
                direction: 'horizontal',
                loop: false,
                freeMode: false,
                slidesPerView: this.querySelectorAll('.swiper-slide').length > 1 ? 1.7 : 1,
                spaceBetween: 10,
                navigation: {
                    nextEl: this.querySelector('.swiper-button-next'),
                    prevEl: this.querySelector('.swiper-button-prev')
                },
                pagination: {
                    el: this.querySelector('.swiper-pagination'),
                    type: 'bullets',
                }
            })
        }
    }

    checkCookie() {
        let samplingVersion = this.getCookie("sampling_version");
        if (samplingVersion != 'S1') {
            window.ElevarDataLayer = window.ElevarDataLayer || [];
            window.ElevarDataLayer.push({ event: "dl_sampling", sampling_type: 'S2' });
            return true;
        } else {
            return false
        }
    }
    
    getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
    }

    handleRecharge() {
        if(typeof reChargeCartJS == 'function') {
            console.log('CU - sample 2')
            let hasSubscriptions = false
            const newItems = document.querySelectorAll('.cart-item');
            newItems.forEach((item)=>{
                if(item.dataset.isSubscription) {
                    if(JSON.parse(item.dataset.isSubscription)) {
                        hasSubscriptions = true
                    }
                }
            })
            window.ReCharge.cart_options.disable = !hasSubscriptions;
            reChargeCartJS()
        } 
    }
}

customElements.define('free-samples2', FreeSamples2);
